import "core-js/modules/es.function.name.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React, { useContext } from 'react';
import { Box } from '@applyboard/ui-components';
import { SimplifiedCheckEligibilityButton } from '@applyboard/dsj-ui';
import { verifyRole } from '@applyboard/ui-utils';
import { Commissions, ProgramInfo, Intakes, AdminComments, ValueAddedServices, PostGraduationPermit } from "../../components";
import { displayDesktopOnly, mobileBottomBorder } from "../../consts";
import { AppContext } from "../../context";
export var RightColumn = function RightColumn(_ref) {
  var _programInitialProps$, _programInitialProps$2, _programInitialProps$3, _programInitialProps$4, _programInitialProps$5, _programInitialProps$6, _initialProps$schoolI, _initialProps$schoolI2;
  var openModal = _ref.openModal,
    programInitialProps = _ref.programInitialProps,
    programData = _ref.programData,
    schoolName = _ref.schoolName,
    livingCost = _ref.livingCost,
    intakes = _ref.intakes,
    commissionData = _ref.commissionData,
    currentUser = _ref.currentUser,
    programRequirements = _ref.programRequirements,
    eligibilities = _ref.eligibilities;
  var _useContext = useContext(AppContext),
    hideEligibility = _useContext.hideEligibility,
    initialProps = _useContext.initialProps;
  var showPgwpEligibility = programInitialProps.country.pgwpVisible && !verifyRole.isVisitor(currentUser);
  var showGic = !!(programInitialProps !== null && programInitialProps !== void 0 && (_programInitialProps$ = programInitialProps.featureFlags) !== null && _programInitialProps$ !== void 0 && (_programInitialProps$2 = _programInitialProps$.showVas) !== null && _programInitialProps$2 !== void 0 && _programInitialProps$2.gic);
  var showLoan = !!(programInitialProps !== null && programInitialProps !== void 0 && (_programInitialProps$3 = programInitialProps.featureFlags) !== null && _programInitialProps$3 !== void 0 && (_programInitialProps$4 = _programInitialProps$3.showVas) !== null && _programInitialProps$4 !== void 0 && _programInitialProps$4.loan);
  var showApplyShop = !!(programInitialProps !== null && programInitialProps !== void 0 && (_programInitialProps$5 = programInitialProps.featureFlags) !== null && _programInitialProps$5 !== void 0 && (_programInitialProps$6 = _programInitialProps$5.showVas) !== null && _programInitialProps$6 !== void 0 && _programInitialProps$6.applyShop);
  var showValueAddedServicesCard = showGic || showLoan || showApplyShop;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideEligibility && /*#__PURE__*/React.createElement(Box, {
    mb: 5,
    display: displayDesktopOnly,
    borderBottom: mobileBottomBorder
  }, /*#__PURE__*/React.createElement(SimplifiedCheckEligibilityButton, {
    programId: programData.id,
    programName: programData.name,
    programLevel: programData.level,
    schoolId: initialProps === null || initialProps === void 0 ? void 0 : initialProps.schoolId,
    schoolCountry: initialProps === null || initialProps === void 0 ? void 0 : initialProps.country.name,
    eligibility: eligibilities[programData.id],
    onClick: openModal,
    variant: "outlined",
    fullWidth: true,
    eventTrackingPrefix: "Programs Page",
    featureFlags: initialProps === null || initialProps === void 0 ? void 0 : initialProps.featureFlags
  })), /*#__PURE__*/React.createElement(AdminComments, {
    comments: programRequirements === null || programRequirements === void 0 ? void 0 : programRequirements.adminComments
  }), /*#__PURE__*/React.createElement(Box, {
    mb: {
      xs: 2,
      md: 5
    },
    borderBottom: mobileBottomBorder
  }, /*#__PURE__*/React.createElement(ProgramInfo, {
    currency: programInitialProps.currency,
    otherFees: programData.otherFees,
    levelText: programData.levelText,
    tuition: programData.tuition,
    applicationFee: programData.applicationFee,
    livingCost: livingCost,
    lengthBreakdown: programData.lengthBreakdown,
    canViewFees: programInitialProps.permissions.viewRequirementsAndFees
  })), /*#__PURE__*/React.createElement(Box, {
    mb: {
      xs: 2,
      md: 5
    },
    borderBottom: mobileBottomBorder
  }, /*#__PURE__*/React.createElement(Intakes, {
    intakes: intakes,
    showCloseConditonToUser: !verifyRole.isVisitor(currentUser)
  })), showPgwpEligibility && /*#__PURE__*/React.createElement(Box, {
    mb: 5
  }, /*#__PURE__*/React.createElement(PostGraduationPermit, {
    title: programInitialProps.country.pgwpTitle,
    pgwpTextHtml: programInitialProps.country.pgwpText
  })), programInitialProps.permissions.viewCommission && /*#__PURE__*/React.createElement(Box, {
    mb: 5
  }, /*#__PURE__*/React.createElement(Commissions, {
    commission: commissionData,
    currency: programInitialProps.currency,
    role: currentUser === null || currentUser === void 0 ? void 0 : currentUser.role
  })), showValueAddedServicesCard && /*#__PURE__*/React.createElement(Box, {
    mb: {
      xs: 2,
      md: 5
    },
    borderBottom: mobileBottomBorder
  }, /*#__PURE__*/React.createElement(ValueAddedServices, {
    showApplyShop: showApplyShop,
    showGic: showGic,
    showLoan: showLoan,
    programId: programData.id,
    programName: programData.name,
    schoolId: (_initialProps$schoolI = initialProps === null || initialProps === void 0 ? void 0 : (_initialProps$schoolI2 = initialProps.schoolId) === null || _initialProps$schoolI2 === void 0 ? void 0 : _initialProps$schoolI2.toString()) !== null && _initialProps$schoolI !== void 0 ? _initialProps$schoolI : '',
    schoolName: schoolName
  })));
};